import React, { useEffect } from "react";
import styled from "styled-components";
import { Modal, Dropdown, Alert } from "antd";
import { Formik } from "formik";
import ButtonWrapper from "./ButtonWrapper";

const StyledWrapper = styled(Alert)`
  border-radius: 6px;
  .ant-alert-message {
    font-size: 20px;
    color: red;
  }
  &.ant-alert {
    font-size: 24px !important;
    line-height: 1;
  }
`;

const AlertMessageWrapper = (props) => {
  return <StyledWrapper {...props} />;
};

export default AlertMessageWrapper;
